/**
 * PreviousEntityTypeName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityTypeName from '../EntityTypeName';

// Selectors
import { makeSelectPreviousEntityTypeValue } from '../../services/entityTypes/selectors';

interface Props {
    entityTypeId?: number;
    plural?: boolean;
}

export class PreviousEntityTypeName extends React.PureComponent<Props> {
    static defaultProps = {
        plural: false
    };

    render() {
        const { entityTypeId, plural } = this.props;
        return <EntityTypeName entityTypeId={entityTypeId} plural={plural} />;
    }
}

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectPreviousEntityTypeValue('id')
});

export default connect(mapStateToProps)(PreviousEntityTypeName);
